export const REQUEST_MASTER_GIFTS = "REQUEST_MASTER_GIFTS";
export const SET_MASTER_GIFTS = "SET_MASTER_GIFTS";
export const ERROR_GET_MASTER_GIFTS = "ERROR_GET_MASTER_GIFTS";

export const REQUEST_CREATE_MASTER_GIFTS = "REQUEST_CREATE_MASTER_GIFTS";
export const SUCCESS_CREATE_MASTER_GIFTS = "SUCCESS_CREATE_MASTER_GIFTS";
export const ERROR_CREATE_MASTER_GIFTS = "ERROR_CREATE_MASTER_GIFTS";

export const REQUEST_UPDATE_MASTER_GIFTS = "REQUEST_UPDATE_MASTER_GIFTS";
export const SUCCESS_UPDATE_MASTER_GIFTS = "SUCCESS_UPDATE_MASTER_GIFTS";
export const ERROR_UPDATE_MASTER_GIFTS = "ERROR_UPDATE_MASTER_GIFTS";

export const REQUEST_DELETE_MASTER_GIFTS = "REQUEST_DELETE_MASTER_GIFTS";
export const SUCCESS_DELETE_MASTER_GIFTS = "SUCCESS_DELETE_MASTER_GIFTS";
export const ERROR_DELETE_MASTER_GIFTS = "ERROR_DELETE_MASTER_GIFTS";

export const SET_MESSAGE_MASTER_GIFTS = "SET_MESSAGE_MASTER_GIFTS";
